export function attachConceptNoImage($context) {
    if (!$context.length) {
        return;
    }

    const $stimuliAdditionalDataDivs = $context.find('.stimuliAdditionalData');
    $stimuliAdditionalDataDivs.each(function (index, stimuliAdditionalDataDiv) {
        checkCheckbox(stimuliAdditionalDataDiv);
    });

    $context.on('change', ".concept-no-image input[type=checkbox]", function () {
        checkCheckbox($(this).closest('.stimuliAdditionalData'));
    });
}

function checkCheckbox(stimuliAdditionalDataDiv) {
    const checkbox = $(stimuliAdditionalDataDiv).find('.concept-no-image input[type=checkbox]');
    if ($(checkbox).is(':checked')) {
        hideImageFile(stimuliAdditionalDataDiv);
        disableChangeImageButton(stimuliAdditionalDataDiv);

        return;
    }

    showImageFile(stimuliAdditionalDataDiv);
    enableChangeImageButton(stimuliAdditionalDataDiv);
}

function showImageFile(stimuliAdditionalDataDiv) {
    const $image = $(stimuliAdditionalDataDiv).find('.categoryPic img');
    $image.css('display', 'inline');
}

function hideImageFile(stimuliAdditionalDataDiv) {
    const $image = $(stimuliAdditionalDataDiv).find('.categoryPic img');
    $image.css('display', 'none');
}

function disableChangeImageButton(stimuliAdditionalDataDiv) {
    const $button = $(stimuliAdditionalDataDiv).find('#btnGroupChangeImage');
    $button.prop('disabled', true);
}

function enableChangeImageButton(stimuliAdditionalDataDiv) {
    const $button = $(stimuliAdditionalDataDiv).find('#btnGroupChangeImage');
    $button.prop('disabled', false);
}
